module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "formulario",
    attrs: {
      "id": "contato_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.enviaEmail($event)
      }
    }
  }, [(_vm.statusEnvio == 1) ? _c('mensagem', {
    staticClass: "-warn"
  }, [_c('p', [_vm._v(_vm._s(_vm.mensagemRetorno))])]) : _vm._e(), (_vm.statusEnvio == 2) ? _c('mensagem', {
    staticClass: "-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.mensagemRetorno))])]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosFormulario.nome),
      expression: "dadosFormulario.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nome"
    },
    domProps: {
      "value": (_vm.dadosFormulario.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosFormulario, "nome", $event.target.value)
      }
    }
  }), (_vm.mensagensErro.erroNome.length > 0) ? _c('span', [_c('small', [_vm._v(_vm._s(_vm.mensagensErro.erroNome))])]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosFormulario.email),
      expression: "dadosFormulario.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email"
    },
    domProps: {
      "value": (_vm.dadosFormulario.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosFormulario, "email", $event.target.value)
      }
    }
  }), (_vm.mensagensErro.erroEmail.length > 0) ? _c('span', [_c('small', [_vm._v(_vm._s(_vm.mensagensErro.erroEmail))])]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "assunto"
    }
  }, [_vm._v("Assunto")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosFormulario.assunto),
      expression: "dadosFormulario.assunto"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "assunto"
    },
    domProps: {
      "value": (_vm.dadosFormulario.assunto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosFormulario, "assunto", $event.target.value)
      }
    }
  }), (_vm.mensagensErro.erroAssunto.length > 0) ? _c('span', [_c('small', [_vm._v(_vm._s(_vm.mensagensErro.erroAssunto))])]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Mensagem")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosFormulario.mensagem),
      expression: "dadosFormulario.mensagem"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7"
    },
    domProps: {
      "value": (_vm.dadosFormulario.mensagem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosFormulario, "mensagem", $event.target.value)
      }
    }
  }), (_vm.mensagensErro.erroMensagem.length > 0) ? _c('span', [_c('small', [_vm._v(_vm._s(_vm.mensagensErro.erroMensagem))])]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Verificação")]), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "font-family": "Arial"
    }
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.expressao))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultadoExpressao),
      expression: "resultadoExpressao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "verificacao",
      "placeholder": "???"
    },
    domProps: {
      "value": (_vm.resultadoExpressao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resultadoExpressao = $event.target.value
      }
    }
  })]), (_vm.mensagensErro.erroExpressao.length > 0) ? _c('span', [_c('small', [_vm._v(_vm._s(_vm.mensagensErro.erroExpressao))])]) : _vm._e()]), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "reset"
    }
  }, [_vm._v("Limpar")]), _c('button', {
    staticClass: "btn btn-form",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Enviar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6312e61a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/Formulario.vue
// module id = 492
// module chunks = 0